// src/modals/order-details/productTable.js
import React from "react";
import { formatCurrency } from "../../helpers/utils";

export default function ProductTable({ products = [], order = null, address, phone, etype, ebarimt }) {
  const handlePrint58mm = () => {
    const w = window.open("", "_blank");
    if (!w) {
      alert("Pop-up blocked байна. Browser дээр Pop-ups allow хийнэ үү.");
      return;
    }

    console.log("------Product:", order);

    const itemsHtml =
      Array.isArray(products) && products.length
        ? products
            .map((p, i) => {
              const name = p?.name || "-";
              const price = Number(p?.price || 0);
              const qty = Number(p?.quantity || 0);
              const amount = Number(p?.amount ?? price * qty);

              return `
                <div class="item">
                  <div class="item-name"><b>${i + 1}. ${escapeHtml(name)}</b></div>

                  <div class="item-line">
                    <div class="left">${escapeHtml(formatCurrency(price))} × ${qty}</div>
                    <div class="right">${escapeHtml(formatCurrency(amount))}</div>
                  </div>
                </div>
              `;
            })
            .join("")
        : `<div class="muted">Бараа байхгүй</div>`;

    const computedTotal = products.reduce((sum, p) => {
      const price = Number(p?.price || 0);
      const qty = Number(p?.quantity || 0);
      const amount = Number(p?.amount ?? price * qty);
      return sum + amount;
    }, 0);

    const totalAmount =
      Number(order?.totalAmount ?? order?.total ?? 0) || computedTotal;

    const orderCode = order?.orderCode ? `#${order.orderCode}` : "";
    const createdAt = order?.createdAt || "-";

    // ✅ Props-оор орж ирсэн phone/address-г л хэвлэнэ
    const phoneVal = phone || "-";
    const addressVal = address || "-";

    // ✅ И-Баримт: PERSON/COMPANY + регистер
    const ebarimtType = etype || "-";
    const ebarimtRegister = ebarimt || "-";

    const ebarimtText =
      ebarimtType === "COMPANY"
        ? `Байгууллага${ebarimtRegister ? ` (${ebarimtRegister})` : ""}`
        : ebarimtType === "PERSON"
        ? "Хувь хүн"
        : "-";

    const html = `
<!doctype html>
<html>
<head>
  <meta charset="utf-8" />
  <title>58mm</title>
  <style>
    @page { size: 58mm auto; margin: 0; }

    html, body {
      margin: 0;
      padding: 0;
      width: 58mm;
      background: #fff;
    }

    body {
      padding: 3mm 3mm;
      font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono","Courier New", monospace;
      font-size: 12px;
      line-height: 1.25;
      color: #000;

      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
      text-rendering: geometricPrecision;
      -webkit-font-smoothing: none;
      font-smooth: never;
      letter-spacing: 0.1px;
    }

    .receipt { width: 58mm; }
    .center { text-align: center; }
    .title { font-size: 14px; font-weight: 800; margin: 0 0 6px 0; }
    .divider { border-top: 1px dashed #000; margin: 6px 0; }

    .meta {
      font-size: 11px;
      margin: 2px 0;
      display: flex;
      justify-content: space-between;
      gap: 6px;
    }

    .meta .label { white-space: nowrap; }
    .meta .value { text-align: right; font-weight: 700; }

    .muted { font-size: 11px; }

    .item { margin: 6px 0; }
    .item-name { margin-bottom: 2px; }

    .item-line {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      gap: 6px;
      font-size: 12px;
    }
    .left { flex: 1; }
    .right {
      min-width: 20mm;
      text-align: right;
      font-weight: 900;
    }

    .total-line {
      display: flex;
      justify-content: space-between;
      font-size: 13px;
      font-weight: 900;
    }
  </style>
</head>

<body>
  <div class="receipt">
    <div class="center title">Захиалгын баримт</div>

    ${
      orderCode
        ? `<div class="meta"><div class="label">Захиалга</div><div class="value">${escapeHtml(
            orderCode
          )}</div></div>`
        : ""
    }

    <div class="meta"><div class="label">Огноо</div><div class="value">${escapeHtml(
      createdAt
    )}</div></div>

    <div class="meta"><div class="label">Утас</div><div class="value">${escapeHtml(
      phoneVal
    )}</div></div>

    <div class="meta">
      <div class="label">Хаяг</div>
      <div class="value" style="max-width:34mm; word-break: break-word;">${escapeHtml(
        addressVal
      )}</div>
    </div>

    <div class="meta"><div class="label">И-Баримт</div><div class="value">${escapeHtml(
      ebarimtText
    )}</div></div>

    <div class="divider"></div>

    ${itemsHtml}

    <div class="divider"></div>

    <div class="total-line">
      <div>НИЙТ</div>
      <div>${escapeHtml(formatCurrency(totalAmount))}</div>
    </div>

    <div class="divider"></div>
    <div class="center muted">Баярлалаа 🙏</div>

    <script>
      window.onload = function () {
        setTimeout(function(){
          window.focus();
          window.print();
          setTimeout(function(){ window.close(); }, 400);
        }, 250);
      };
    </script>
  </div>
</body>
</html>
`;

    w.document.open();
    w.document.write(html);
    w.document.close();
  };

  return (
    <>
      <div className="table-responsive">
        <table className="table table-centered mb-0">
          <thead>
            <tr>
              <th className="col-1 text-center">#</th>
              <th className="col-2 text-center">Зураг</th>
              <th className="col text-center">Бараа</th>
              <th className="col-2 text-center">Үнэ</th>
              <th className="col-1 text-center">Тоо</th>
            </tr>
          </thead>
          <tbody>
            {products?.map((product, index) => (
              <tr key={product.id || index}>
                <td className="text-center">{index + 1}</td>
                <td className="text-center">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="img-fluid avatar-sm rounded"
                  />
                </td>
                <td className="text-center">{product.name}</td>
                <td className="text-center">{formatCurrency(product.price)}</td>
                <td className="text-center">
                  {product.quantity > 1 ? (
                    <span className="badge bg-danger px-2 py-1 fs-5">
                      {product.quantity}
                    </span>
                  ) : (
                    product.quantity
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="d-flex justify-content-end mt-3">
        <button
          type="button"
          className="btn btn-outline-primary"
          style={{ width: 140 }}
          onClick={handlePrint58mm}
        >
          <i className="ri-printer-line me-2" />
          Хэвлэх (58мм)
        </button>
      </div>
    </>
  );
}

function escapeHtml(str) {
  return String(str ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}
